import { Fragment } from 'react';
import { DialogPanel as _DialogPanel, type DialogPanelProps, TransitionChild } from '@headlessui/react';
import cns from 'classnames';
import S from './DialogPanel.module.scss';

//dialog overlay에 transition을 넣을지 여부를 결정하는 props를 추가하였습니다.
//default로 transition이 있도록 설정하였습니다.
export const DialogPanel = (props: DialogPanelProps<'div'>) => {
  const {
    className,
    children,
    transition = true
  } = props;
  return <TransitionChild transition={transition} as={Fragment} enter={S.enter} enterFrom={S.enter_from} enterTo={S.enter_to} leave={S.leave} leaveFrom={S.leave_from} leaveTo={S.leave_to} data-sentry-element="TransitionChild" data-sentry-component="DialogPanel" data-sentry-source-file="DialogPanel.tsx">
      <_DialogPanel {...props} className={cns(S.panel, className as string)} tabIndex={0} data-sentry-element="_DialogPanel" data-sentry-source-file="DialogPanel.tsx">
        {children}
      </_DialogPanel>
    </TransitionChild>;
};